
export const toDataUri = (b64: string | undefined) => {
  return b64 ? `data:image/png;base64,${b64}` : b64;
};
